import { SERVICES, MANAGEMENT, IMG, waLink } from "../data/content";
import { PageHero, Chapter, Reveal, Btn, useTitle } from "../components/shared";
import { WhatsAppIcon } from "../components/Navbar";

export default function Services() {
  useTitle("Services | The Big Wedd — Weddings, Corporate, Social & Destination Events");
  return (
    <main>
      <PageHero
        eyebrow="Services"
        title={[<span key="t">Everything your celebration <span className="italic text-gold-light">needs</span></span>]}
        sub="Weddings, corporate events, social celebrations and artists — planned, designed and executed under one roof."
        img={IMG.servicesHero}
      />

      <section className="bg-ivory py-24 md:py-32" data-testid="services-list">
        <div className="mx-auto max-w-7xl space-y-24 px-6 md:px-12">
          {SERVICES.map((s, i) => (
            <div key={s.title} className={`grid items-center gap-10 md:grid-cols-2 md:gap-16 ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
              <Reveal>
                <div className="gold-frame overflow-hidden">
                  <img src={s.img} alt={s.title} loading="lazy" className="h-72 md:h-[440px] w-full object-cover transition-transform duration-[1.6s] hover:scale-105" />
                </div>
              </Reveal>
              <div>
                <Chapter num={`S${i + 1}`} title={s.tag} />
                <Reveal delay={0.1}>
                  <h2 className="mt-5 font-serif text-3xl md:text-5xl text-emerald leading-tight">{s.title}</h2>
                  <p className="mt-4 text-sm md:text-base text-stone2">{s.desc}</p>
                </Reveal>
                <Reveal delay={0.2}>
                  <div className="mt-6 flex flex-wrap gap-2.5">
                    {s.items.map((it) => (
                      <span key={it} className="rounded-full border border-gold/35 px-4 py-2 text-[11px] uppercase tracking-[0.12em] text-stone2 transition-colors hover:border-gold hover:text-gold-text" data-testid={`service-item-${i}`}>
                        {it}
                      </span>
                    ))}
                  </div>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="relative overflow-hidden bg-emerald-deep py-24 md:py-32" data-testid="end-to-end-management">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Chapter num="E2E" title="End-to-End Wedding Management" dark />
          <Reveal delay={0.1}>
            <h2 className="mt-6 max-w-3xl font-serif text-4xl md:text-6xl leading-[1.05] text-ivory">
              The entire wedding journey, <span className="italic text-gold-light">handled</span>
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-x-10 gap-y-2 sm:grid-cols-2">
            {MANAGEMENT.map((m, i) => (
              <Reveal key={m.title} delay={i * 0.04}>
                <div className="flex gap-5 border-b border-gold/15 py-5" data-testid={`management-item-${i}`}>
                  <span className="font-serif text-2xl italic text-gold/80">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-serif text-xl md:text-2xl text-ivory">{m.title}</h3>
                    <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-ivory/55">{m.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-14 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Btn to="/contact" testid="services-cta">Plan My Wedding</Btn>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="services-cta-whatsapp" className="inline-flex items-center gap-3 rounded-full border border-ivory/50 px-8 py-4 text-[11px] md:text-xs font-medium uppercase tracking-[0.22em] text-ivory transition-all duration-500 hover:bg-ivory hover:text-emerald">
                <WhatsAppIcon className="h-4 w-4" /> Chat On WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
